import React, { useEffect, useRef, useState } from 'react';
import { useLocation, Link } from "react-router-dom";
import { theme as themeConfig } from "../../themes/themes";
import { ReactComponent as MenuHomeIcon } from "../../assets/svg/menu-home-icon.svg";
import { ReactComponent as MenuQuickAssistIcon } from "../../assets/svg/menu-quickassist-icon.svg";
import { ReactComponent as MenuSurveysIcon } from "../../assets/svg/menu-surveys-icon.svg";
import { ReactComponent as MenuCalendarIcon } from "../../assets/svg/menu-calendar-icon.svg";
import { ReactComponent as MenuCoachIcon } from "../../assets/svg/menu-coach-icon.svg";
import { ReactComponent as MenuEngagementIcon } from "../../assets/svg/menu-engagement-icon.svg";
import { ReactComponent as MenuGamificationIcon } from "../../assets/svg/menu-gamification-icon.svg";
import { ReactComponent as MenuReportsIcon } from "../../assets/svg/menu-reports-icon.svg";
import { ReactComponent as MenuPolicyInsightsIcon } from "../../assets/svg/menu-policyinsights-icon.svg";
import { ReactComponent as MenuResourcesIcon } from "../../assets/svg/menu-resources-icon.svg";
import { ReactComponent as MenuSiteManagementIcon } from "../../assets/svg/menu-sitemanagement-icon.svg";
import { ReactComponent as MainMenuForwardIcon } from "../../assets/svg/main-menu-forward-arrow.svg";
import SearchIcon from "@material-ui/icons/Search";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import SideMenuButtonComponent from '../../containers/SideMenuButton/SideMenuButton';
import { ContentChoice, ContentMenu, GroupingName, IconCollapseStyle, MenuIcons, SearchField, SubGroupHR, SubGroupingName } from './SideMenu.styled';
import { Clear } from "@material-ui/icons";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import { ReactComponent as MenuIconCollapse } from "../../assets/svg/menu-icon-collapse.svg";
import { ReactComponent as MenuIconExpand } from "../../assets/svg/menu-icon-expand.svg";
import { ROLES } from '../../util/RolesConstants';
import { Form } from 'react-bootstrap';
import PropTypes from "prop-types";

const SideMenu = ({
  menuClass,
  user,
  isCollapse,
  setIsCollapse,
  handleDrawer,
  choiceSelected,
  setChoiceSelected,
  menuList,
  setShowICE,
  ICEStatus,
  activeIceButton,
}) => {
  const [searchData, setSearchData] = useState(menuList);
  const groupName = useRef({});
  const location = useLocation();
  const [, setForceRender] = useState(false);
  const rSearch = useRef();

  const isMenuOrSubmenuSelected = (menuId, submenuData) => {
    if (choiceSelected.menu === menuId) return true;
    if (submenuData?.data) {
      const submenuIds = submenuData.data.map(s => s.id);
      return submenuIds.includes(choiceSelected.submenu);
    }
    return false;
  };

  useEffect(() => {
    groupName.current = {};
    setForceRender((prev) => !prev);
  }, [location.pathname]);

  useEffect(() => {
    setSearchData(menuList);
  }, [menuList]);

  const handleSearch = (e) => {
    if (!e.target.value) {
      setSearchData(menuList);
      return;
    }
    setSearchData(
      menuList.filter((x) =>
        x.text.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  };

  const getMenuIcon = (icon, color) => {
    switch (icon) {
      case "home":
        return <MenuHomeIcon style={{ fill: color }} />;
      case "widgets_icon":
        return <MenuQuickAssistIcon style={{ fill: color }} />;
      case "assignment":
        return <MenuSurveysIcon style={{ fill: color }} />;
      case "forms":
        return <MenuSurveysIcon style={{ fill: color }} />;
      case "calendar_today":
        return <MenuCalendarIcon style={{ fill: color }} />;
      case "person":
        return <MenuCoachIcon style={{ fill: color }} />;
      case "library_books":
        return <MenuEngagementIcon style={{ fill: color }} />;
      case "videogame_asset":
        return <MenuGamificationIcon style={{ fill: color }} />;
      case "insert_chart":
        return <MenuReportsIcon style={{ fill: color }} />;
      case "local_police":
        return <MenuPolicyInsightsIcon style={{ fill: color }} />;
      case "file_open_icon":
        return <MenuResourcesIcon style={{ fill: color }} />;
      case "settings":
        return <MenuSiteManagementIcon style={{ fill: color }} />;
      case "report":
        return <MenuReportsIcon style={{ fill: color }} />;
      default:
        return <Icon className="widget-icon" style={{ color }}>{icon}</Icon>;
    }
  };

  const getSubmenuItems = (m, i, menuSeparatorClass, menuPaddingClass) => {
    const isSelected = isMenuOrSubmenuSelected(m.id, m.submenu);
    return (
      <SubMenu
        className={`choiceSelected-${m.id} submenu-hover ${menuPaddingClass + menuSeparatorClass} ${isSelected ? 'pro-menu-item--active' : ''}`}
        key={i}
        title={
          <ContentChoice color={m.color}>
            <MenuIcons isSelected={isSelected}>
              {getMenuIcon(m.icon, isSelected ? themeConfig.sidebar.selectedText : themeConfig.neutral.iconGray)}
            </MenuIcons>
            {isCollapse && (
              <MainMenuForwardIcon style={{ marginBottom: "4px" }} />
            )}
            <span style={{ fontSize: "16px", fontFamily: "'TP Sans', sans-serif", fontWeight: 400 }}>
              {!isCollapse && m.text}
            </span>
          </ContentChoice>
        }
      >
        {isCollapse && m.submenu.idParentMenu && (
          <div style={{ padding: "0 1rem 0 1rem", marginTop: "0.5rem" }}>
            {m.submenu.idParentMenu === 1 && (
              <SubGroupingName>Surveys</SubGroupingName>
            )}
            {m.submenu.idParentMenu === 7 && (
              <SubGroupingName>Calendar</SubGroupingName>
            )}
            {m.submenu.idParentMenu === 73 && (
              <SubGroupingName>Forms</SubGroupingName>
            )}
            {m.submenu.idParentMenu === 15 && (
              <SubGroupingName>My Coach</SubGroupingName>
            )}
            {m.submenu.idParentMenu === 28 && (
              <SubGroupingName>Engagement</SubGroupingName>
            )}
            {m.submenu.idParentMenu === 47 && (
              <SubGroupingName>Gamification</SubGroupingName>
            )}
            {m.submenu.idParentMenu === 4 && (
              <SubGroupingName>Reports</SubGroupingName>
            )}
            {m.submenu.idParentMenu === 64 && (
              <SubGroupingName>Policy Insights</SubGroupingName>
            )}
            {m.submenu.idParentMenu === 12 && (
              <SubGroupingName>Site Management</SubGroupingName>
            )}
            {m.submenu.idParentMenu === 78 && (
              <SubGroupingName>Quick Assist</SubGroupingName>
            )}
            <SubGroupHR></SubGroupHR>
          </div>
        )}
        {m.submenu?.data?.map((s, i) => {
          const isSubmenuSelected = choiceSelected.submenu === s.id;
          return (
            <MenuItem
              style={{
                display: s.text !== "Menu and Access Management" ? "block" : "none",
              }}
              className={`subchoiceSelected-${s.id} ${isSubmenuSelected ? 'pro-menu-item--active' : ''}`}
              key={i}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontFamily: "'TP Sans', sans-serif",
                  fontWeight: isSubmenuSelected ? "600" : "400",
                }}
              >
                {s.text !== "Menu and Access Management" ? s.text : ""}
              </span>
              <Link
                to={{
                  pathname: s.route,
                  topBanner: s.topBanner,
                }}
                onClick={() =>
                  setChoiceSelected({
                    menu: m.id,
                    submenu: s.id,
                  })
                }
              />
            </MenuItem>
          );
        })}
      </SubMenu>
    );
  };

  const showSideMenuButton = (isActiveCollapse) => {
    return isActiveCollapse ? (
      <SideMenuButtonComponent
        someProp="tab-mobile-menu"
        setShowICE={setShowICE}
        activeIceButton={activeIceButton}
        ICEStatus={ICEStatus}
      />
    ) : (
      <SideMenuButtonComponent
        someProp="desktop-menu"
        setShowICE={setShowICE}
        activeIceButton={activeIceButton}
        ICEStatus={ICEStatus}
      />
    );
  };

  return (
    <ContentMenu
      isSelected={
        !!searchData.find((m) => {
          return choiceSelected.menu === m.id;
        })
      }
      className={menuClass}
      isVisible={user}
      isCollapse={isCollapse}
    >
      <ProSidebar
        collapsed={isCollapse}
        width={206}
        collapsedWidth={58}
        className="pro-sidebar-principal"
      >
        {menuClass === "tab-mobile-menu" && (
          <IconCollapseStyle>
            <IconButton
              onClick={() => {
                setIsCollapse(!isCollapse);
              }}
            >
              {isCollapse && <MenuIconCollapse />}
              {!isCollapse && <MenuIconExpand />}
            </IconButton>
          </IconCollapseStyle>
        )}
        <Menu iconShape="square">
          {ROLES.AGENT === user.roleId ? showSideMenuButton(isCollapse) : null}
          {isCollapse ? (
            <div style={{ display: "flex", justifyContent: "center", padding: "10px 0" }}>
              <SearchIcon style={{ color: themeConfig.neutral.iconGray }} />
            </div>
          ) : (
            <SearchField>
              <Form.Control
                type="text"
                placeholder="Search"
                onChange={handleSearch}
                ref={rSearch}
              />
              {rSearch.current?.value ? (
                <Clear
                  style={{
                    color: themeConfig.neutral.gray[2600],
                    width: "1rem",
                    height: "1rem",
                    cursor: "pointer",
                    flexShrink: 0,
                  }}
                  onClick={() => {
                    rSearch.current.value = "";
                    setSearchData(menuList);
                  }}
                />
              ) : (
                <SearchIcon style={{ color: themeConfig.neutral.iconGray, flexShrink: 0 }} />
              )}
            </SearchField>
          )}
          {searchData.map((m, i) => {
            const updateGroupName = () => {
              if (isCollapse) {
                groupName.current = {};
                return <></>;
              } else {
                groupName.current[m.groupMenu] = true;
                return <></>;
              }
            };
            let menuSeparatorClass = [1, 15, 47, 62].includes(m.id)
              ? " menu-separator "
              : "";
            let menuPaddingClass = [].includes(m.id)
              ? " menu-padding-top "
              : "";
            if (m?.submenu?.data?.length && m?.submenu?.data?.length > 1) {
              return isCollapse ? (
                getSubmenuItems(m, i, menuSeparatorClass, menuPaddingClass)
              ) : (
                <>
                  {!groupName.current[m.groupMenu] && m.groupMenu && (
                    <GroupingName>{m.groupMenu.toUpperCase()}</GroupingName>
                  )}
                  {updateGroupName()}
                  {getSubmenuItems(m, i, menuSeparatorClass, menuPaddingClass)}
                </>
              );
            } else {
              const isSelected = isMenuOrSubmenuSelected(m.id, m.submenu);
              return (
                <MenuItem
                  key={i}
                  style={{ minWidth: "65px" }}
                  className={`choiceSelected-${m.id}${menuPaddingClass + menuSeparatorClass} ${isSelected ? 'pro-menu-item--active' : ''}`}
                >
                  {!isCollapse &&
                    !groupName.current[m.groupMenu] &&
                    m.groupMenu && (
                      <GroupingName style={{ marginLeft: "0rem" }}>
                        {m.groupMenu.toUpperCase()}
                      </GroupingName>
                    )}
                  {updateGroupName()}
                  <ContentChoice
                    color={m.color}
                    onClick={() =>
                      setChoiceSelected({ menu: m.id, submenu: "" })
                    }
                  >
                    <Link
                      to={{
                        pathname: m?.submenu?.data?.[0]?.route ?? m.route,
                        topBanner:
                          m?.submenu?.data?.[0]?.topBanner ?? m?.topBanner,
                      }}
                    />
                    <MenuIcons isSelected={isMenuOrSubmenuSelected(m.id, m.submenu)}>
                      {getMenuIcon(m.icon, isMenuOrSubmenuSelected(m.id, m.submenu) ? themeConfig.sidebar.selectedText : themeConfig.neutral.iconGray)}
                    </MenuIcons>
                    <span
                      style={{
                        fontSize: "16px",
                        fontFamily: "'TP Sans', sans-serif",
                        fontWeight: isMenuOrSubmenuSelected(m.id, m.submenu) ? "700" : "400",
                        color: isMenuOrSubmenuSelected(m.id, m.submenu) ? themeConfig.sidebar.selectedText : themeConfig.text.primary
                      }}
                    >
                      {!isCollapse && m.text}
                    </span>
                  </ContentChoice>
                </MenuItem>
              );
            }
          })}
        </Menu>
      </ProSidebar>
      <div className="sidebar-copyright">
        {!isCollapse && (
          <div className="sidebar-copyright-text">Trust&Safety, </div>
        )}
        <div className="sidebar-copyright-text">Copyright©2021</div>
        {!isCollapse && <div style={{ margin: "0 4px 0 4px" }}>|</div>}
        <div className="sidebar-copyright-anchor">
          <a
            href="https://www.teleperformance.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Teleperformance
          </a>
        </div>
      </div>
    </ContentMenu>
  );
};

export default SideMenu;

SideMenu.propTypes = {
  menuClass: PropTypes.string,
  user: PropTypes.object,
  isCollapse: PropTypes.bool,
  setIsCollapse: PropTypes.func,
  handleDrawer: PropTypes.func,
  choiceSelected: PropTypes.string,
  setChoiceSelected: PropTypes.func,
  menuList: PropTypes.array,
  isModalOpen: PropTypes.bool,
  setIsModalOpen: PropTypes.func,
  setShowICE: PropTypes.func,
  activeIceButton: PropTypes.bool,
  ICEStatus: PropTypes.string,
}

